module.exports = __webpack_public_path__ + "static/img/unxp_member_header_bg.641d2d6a.png";